<!--
 * @Author: zerui.yao
 * @Date: 2022-11-28 10:52:12
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-12-28 14:27:46
 * @FilePath: /fed-authority/src/App.vue
 * @Description: 
-->
<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import { AppDeviceEnquire } from '@/utils/mixin';

const Language = { 'zh-CN': zhCN, 'en-US': enUS };

export default {
  mixins: [AppDeviceEnquire],
  data() {
    return {
      // locale: zhCN,
    };
  },

  computed: {
    locale() {
      // 从state获取当前语言
      // console.log(this.$store.state.system.app.lang);
      return Language[this.$store.state.system.app.lang];
    },
  },
  mounted() {
    // function toTen(num) {
    //   const numArr = String(num).split('');
    //   const len = numArr.length;
    //   let result = 0;
    //   for (let i = 0; i < len; i++) {
    //     result += 2 ** (len - i - 1) * numArr[i];
    //   }
    //   return result;
    // }
    // function toTwo(num) {
    //   let result = '';
    //   let temp = num;
    //   while (temp > 0) {
    //     result = String(temp % 2) + result;
    //     temp = Math.floor(temp / 2);
    //   }
    //   return result;
    // }
  },
};
</script>
<style>
#app {
  height: 100%;
}
</style>
